//Saving new Item
import { firestore, storage } from "../firebase.config";
import { collection, doc, orderBy, query, setDoc, getDocs, deleteDoc, getDoc, updateDoc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage"; // Import ref and deleteObject for storage
import { actionType } from '../context/Reducer'

export const saveItem = async (data) => {
    await setDoc(doc(firestore, 'Products', `${Date.now()}`), data, { merge: true });
};

//Get Details Items

export const getAllItems = async () => {
    const itemsQuery = query(collection(firestore, 'Products'), orderBy('id', 'desc'));
    const querySnapshot = await getDocs(itemsQuery);
    return querySnapshot.docs.map((doc) => doc.data());
};

export const saveCompany = async (data) => {
    // Save the company data with the generated ID in Firestore
    await setDoc(doc(firestore, 'Partner', data.id), data, { merge: true });
};

export const getAllCompany = async () => {
    const itemsQuery = query(collection(firestore, 'Partner'));
    const querySnapshot = await getDocs(itemsQuery);
    return querySnapshot.docs.map((doc) => doc.data());
};
export const saveBlog = async (data) => {
    // Save the company data with the generated ID in Firestore
    await setDoc(doc(firestore, 'Blog', data.id), data, { merge: true });
};

export const getAllBlog = async () => {
    const itemsQuery = query(collection(firestore, 'Blog'));
    const querySnapshot = await getDocs(itemsQuery);
    return querySnapshot.docs.map((doc) => doc.data());
};

export const getAllService = async () => {
    const itemsQuery = query(collection(firestore, 'Service'));
    const querySnapshot = await getDocs(itemsQuery);
    return querySnapshot.docs.map((doc) => doc.data());
};
export const saveServices = async (data) => {
    // Save the company data with the generated ID in Firestore
    await setDoc(doc(firestore, 'Service', data.id), data, { merge: true });
};

export const saveSlider = async (data) => {
    await setDoc(doc(firestore, 'Slider', `${Date.now()}`), data, { merge: true });
};

//Get Details Items

export const getSlider = async () => {
    const itemsQuery = query(collection(firestore, 'Slider'));
    const querySnapshot = await getDocs(itemsQuery);
    return querySnapshot.docs.map((doc) => doc.data());
};
// Delete a slider from Firestore and its associated image from Firebase Storage
export const deleteSlider = async (sliderId, imageUrl) => {
    try {
        // Delete the image from Firebase Storage
        const imageRef = ref(storage, imageUrl);
        await deleteObject(imageRef);

        // Delete the slider document from Firestore
        await deleteDoc(doc(firestore, 'Slider', sliderId)); // Ensure 'Slider' matches your Firestore collection name

    } catch (error) {
        if (error.code === 'storage/object-not-found') {
            console.warn(`Image not found in Firebase Storage: ${imageUrl}. Skipping deletion.`);
            // Continue with deleting the Firestore document
            await deleteDoc(doc(firestore, 'Slider', sliderId));
        } else {
            console.error("Error deleting slider:", error);
        }
    }
};
export const deletePartner = async (partnerId, imageUrl) => {
    try {
        // Delete the image from Firebase Storage
        const imageRef = ref(storage, imageUrl);
        await deleteObject(imageRef);

        // Delete the company document from Firestore
        await deleteDoc(doc(firestore, 'Partner', partnerId)); // Ensure 'Partner' matches your Firestore collection name

    } catch (error) {
        if (error.code === 'storage/object-not-found') {
            console.warn(`Image not found in Firebase Storage: ${imageUrl}. Skipping deletion.`);
            // Continue with deleting the Firestore document
            await deleteDoc(doc(firestore, 'Partner', partnerId));
        } else {
            console.error("Error deleting company:", error);
        }
    }
};


export const deleteBlogs = async (partnerId, imageUrl) => {
    try {
        // Delete the image from Firebase Storage
        const imageRef = ref(storage, imageUrl);
        await deleteObject(imageRef);

        // Delete the company document from Firestore
        await deleteDoc(doc(firestore, 'Blog', partnerId)); 
    } catch (error) {
        if (error.code === 'storage/object-not-found') {
            console.warn(`Image not found in Firebase Storage: ${imageUrl}. Skipping deletion.`);
            // Continue with deleting the Firestore document
            await deleteDoc(doc(firestore, 'Blog', partnerId));
        } else {
            console.error("Error deleting blog:", error);
        }
    }
};

// Fetch Blogs and Dispatch to State
export const fetchBlogs = async (dispatch) => {
    try {
        const blogsCollection = collection(firestore, "Blog"); 
        const blogSnapshot = await getDocs(blogsCollection);
        const blogList = blogSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        dispatch({
            type: actionType.SET_BLOG,
            Blog: blogList,
        });

        console.log("Fetched Blogs:", blogList);
    } catch (error) {
        console.error("Error fetching blogs:", error);
    }
};
export const deleteService = async (partnerId, imageUrl,Bannerimageurl) => {
    try {
        // Delete the image from Firebase Storage
        const imageRef = ref(storage, imageUrl,Bannerimageurl);
        await deleteObject(imageRef);

        // Delete the company document from Firestore
        await deleteDoc(doc(firestore, 'Service', partnerId)); 
    } catch (error) {
        if (error.code === 'storage/object-not-found') {
            console.warn(`Image not found in Firebase Storage: ${imageUrl}. Skipping deletion.`);
            // Continue with deleting the Firestore document
            await deleteDoc(doc(firestore, 'Service', partnerId));
        } else {
            console.error("Error deleting service:", error);
        }
    }
};
export const getServiceById = async (serviceId) => {
    try {
      const serviceDoc = await getDoc(doc(firestore, "Service", serviceId));
      if (serviceDoc.exists()) {
        return { id: serviceDoc.id, ...serviceDoc.data() };
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error getting service by ID:", error);
      throw error;
    }
  };
  
  // Function to update a service
  export const updateService = async (serviceData) => {
    try {
      const serviceDocRef = doc(firestore, "Service", serviceData.id);
      await updateDoc(serviceDocRef, {
        title: serviceData.title,
        description: serviceData.description,
        imageurl: serviceData.imageurl,
        bannercontent :serviceData.bannercontent,
          bannerimageurl :serviceData.bannerimageurl,
      });
    } catch (error) {
      console.error("Error updating service:", error);
      throw error;
    }
  };
  